export enum LiveChatEvent {
  LIVE_CHAT_INIT = "LiveChatInitiatedEvent",
  LIVE_CHAT_CLOSED = "LiveChatClosedEvent",
}
